import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Banner, BannerVariant } from "../../components/Banner";
import { ModalPaidBeforeVisitRequired } from "../../components/ModalPaidBeforeVisitRequired";
import { PageContainer } from "../../components/PageContainer";
import { getCollectionYardPaidBeforeVisitRequired } from "../../selectors/collectionYard";
import { getLocationDetailLocation } from "../../selectors/locationDetail";
import { PaymentStatus } from "../../types/collectionPoint";
import { LocationDetailPageHeaderComponent } from "./LocationDetailPageHeaderComponent";
import { LocationDetailTable } from "./LocationDetailTable";

import styles from "./LocationDetailPage.module.scss";

export const LocationDetailPage: React.FC = () => {
  const { t } = useTranslation();

  const paidBeforeVisitRequired = useSelector(getCollectionYardPaidBeforeVisitRequired);
  const { isPaid } = useSelector(getLocationDetailLocation);

  return (
    <PageContainer HeaderComponent={LocationDetailPageHeaderComponent}>
      <div className={styles.container}>
        {isPaid === PaymentStatus.Unpaid && (
          <>
            <Banner message={t("notPaidWarningMessage")} variant={BannerVariant.Warning} />
          </>
        )}
        {paidBeforeVisitRequired && isPaid === PaymentStatus.Unpaid && <ModalPaidBeforeVisitRequired />}
        <div className={styles.content}>
          <LocationDetailTable />
        </div>
      </div>
    </PageContainer>
  );
};
